<template>
  <router-view></router-view>
</template>

<script>
export default {

  name: 'App',
  components: {
  }
}
</script>

<style>
  body {
    width:100%;
    margin: 0;
    overflow-y: scroll;
    overflow-x: unset;
    font-size: 14px;
    line-height: 1.5;
    background: #fff;
    color: #333;
  }
</style>
